<template>
  <div>
    <div @click.stop="showImageModal = true">
      <slot></slot>
    </div>
    <transition name="fade">
      <Modal v-if="showImageModal" @closeOnOverlay="showImageModal = false" :closeIcon="true">
        <div slot="modal-wrapper">
          <div class="flex justify-center p-1">
            <div
              class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 min-w-full sm:min-w-30 max-w-xl self-start my-16 sm:my-28 relative"
            >
              <button @click="showImageModal = false" class="transform hover:rotate-90 transition-transform duration-500 ease-out w-10 h-10 text-gray-600 absolute right-1 top-1 p-2">
                <CloseIcon />
              </button>
              <img class="w-full" :src="img" />
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import Modal from "@/components/common/Modal";
import CloseIcon from "@/components/common/icons/CloseIcon";
export default {
  name: "LightBoxComponent",
  components: {
    Modal,
    CloseIcon
  },

  props: ["img"],

  data() {
    return {
      imageUrl: "",
      showImageModal: false
    };
  },
};
</script>

<style></style>
